import './title.less'

import {DOMAttrs, View, classes, m} from '@codeurs/front'

export default class Title extends View<
	{
		heading: number
		class?: string
		className?: string
		mod?: any
	} & DOMAttrs
> {
	render = this.render

	view() {
		const {heading = 3, class: c1, className: c2, mod} = this.attrs
		const tag = `h${heading}`
		return m(tag, classes('title', c1, c2, {mod: [tag, mod]}), this.children)
	}
}
